export default __webpack_public_path__ + "static/media/2FA.373eb428.png";